// extracted by mini-css-extract-plugin
export default {"example":"notification_example__w9rAr"};